/** @format */

export const frameMiddle = (store) => (next) => (action) => {
	if (action.type === "frame/initFrame") {
		console.log("Init frame from middle");
	}

	return next(action);
};
